/**
 * Single source of truth for localization namespaces
 * All files should import namespace constants from here
 */

// The 5 official localization namespaces (admin uses hardcoded English, emails use entity-based localization)
export const LOCALIZATION_NAMESPACES = ['common', 'auth', 'pages', 'components', 'feedback'] as const;

// Type for namespace values
export type LocalizationNamespace = typeof LOCALIZATION_NAMESPACES[number];

// For selectors that need an "all" option (array format)
export const NAMESPACE_OPTIONS_WITH_ALL = ['all', ...LOCALIZATION_NAMESPACES] as const;

// For UI selects with labels
export const NAMESPACE_SELECT_OPTIONS = [
  { value: 'all', label: 'All Namespaces' },
  { value: 'common', label: 'Common' },
  { value: 'auth', label: 'Auth' },
  { value: 'pages', label: 'Pages' },
  { value: 'components', label: 'Components' },
  { value: 'feedback', label: 'Feedback' },
] as const;

